import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "aura-chat h-[calc(100dvh-64px)] min-h-0 w-full" }

import { computed, ref, onMounted, watch } from 'vue';
import AuraComposer from '@/views/pages/aura/components/AuraComposer.vue';
import { useAuraStore, useFilterStore } from '@/stores';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuraChat',
  setup(__props) {

/**
 * AURA Chat - Main chat view component
 * Main chat interface integrating all sub-components
 */
const isLoading = ref(true);
const auraStore = useAuraStore();
const filterStore = useFilterStore();
const levelId = computed(() => filterStore.level?.id ?? null);

watch(
    levelId,
    () => {
        auraStore.reset(true);
    },
    { immediate: true },
);

onMounted(async () => {
    // Composer loads the real AURA context from the backend.
    isLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(AuraComposer, {
      key: levelId.value ?? 'no-level',
      "is-loading": isLoading.value
    }, null, 8, ["is-loading"]))
  ]))
}
}

})